export default (state = null, action) => {
  switch (action.type) {
    case 'SET_METRICS':
      return action.metrics;
    default:
      return state;
  }
};
